function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseStock = function SvgCloseStock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 32 32",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26 13h-2V9c0-4.411-3.589-8-8-8S8 4.589 8 9v4H6c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V15c0-1.1-.9-2-2-2zm-9 8.723V25a1 1 0 1 1-2 0v-3.277c-.595-.346-1-.984-1-1.723a2 2 0 1 1 4 0c0 .738-.405 1.376-1 1.723zM20 13h-8V9c0-2.206 1.794-4 4-4s4 1.794 4 4v4z",
    style: {
      fill: "#000",
      stroke: "#000",
      strokeWidth: 0
    }
  }));
};
export default SvgCloseStock;